/* eslint-disable react-hooks/exhaustive-deps */

import "./BusinessDashboardV2.scss";

import { IAPIConfig, useApi } from "../../custom_hooks/useApi";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import AnalyticsTemplate from "../../templates/Analytics/AnalyticsTemplate";
import CustomToast from "../../utils/cutomToast/CustomToast";
import dayjs from "dayjs";
import { useBusinessDashboardApis } from "../../custom_hooks/useBusinessDashboardApis";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

interface Condition {
  condition: string;
  value: string;
}

interface TopicCluster {
  name: string;
  conditions: Condition[];
}

interface ContentGroup {
  name: string;
  conditions: Condition[];
}

interface BusinessProfileSettings {
  uniqueId: string;
  userUniqueId: string;
  brandedKeywords: string[];
  topicClusters: TopicCluster[];
  contentGroups: ContentGroup[];
}

// Define the interface for the card data
// interface CardData {
//   branded: {
//     Percentage: string;
//     Diff: string;
//     Trend: "up" | "down";
//   };
//   intop10: {
//     Percentage: string;
//     Diff: string;
//     Trend: "up" | "down";
//   };
// }

// Interface to define the structure of trend data
interface TrendDetail {
  Total: string; // The Total is stored as a string (e.g., "403")
  Diff: string; // The difference percentage as a string (e.g., "-25.00%")
  Trend: string; // The trend direction as a string (e.g., "down")
}

interface TrendData {
  [key: string]: TrendDetail;
}

// interface LandingPageData {
//   date: {
//     data: string;
//     mainStats: string;
//   };
//   firstUserDefaultChannelGroup: string;
// }

interface ChartData {
  curDate: string;
  preDate: string;
  curData: {
    Sessions: number;
    keyEvents: number;
  };
  preData: {
    "Key events": number;
    Conversions: number;
  };
}

interface BarChartData {
  "FirstUser DefaultChannelGroup": string;
  curData: {
    Sessions: string;
    "Key events": string;
  };
}

const BusinessDashboardV2 = () => {
  const {
    FetchSearchAnalytics,
    FetchGA4Data,
    FetchLocalPresence,
    FetchAISearchData,
  } = useBusinessDashboardApis();
  const {
    searchConsoleDate,
    searchConsolePage,
    searchConsoleQuery,
    searchConsoleFunnelData,
    searchConsoleTrendData,
    searchConsoleQueryClusters,
    searchConsoleContentGroups,
    landingPageData,
    localPresence,
    searchAiData,
  } = useSelector((state: any) => state.businessdashboardDetails);

  const profileData = useSelector(
    (state: any) => state.businessDetails.profileDataByUniqueID
  );
  const [ChartData, setChartData] = useState<
    { name: string; data: number[] }[]
  >([]);
  const [ChartKey, setChartKey] = useState<string[]>([]);
  //const [cards, setCards] = useState<CardData | null>(null);
  const [funnelData, setFunnelData] = useState<any>({});
  const [queriesData, setQueriesData] = useState<any[]>([]);
  const [contentData, setContentData] = useState<any[]>([]);
  const [queryClustersData, setQueryClustersData] = useState<any[]>([]);
  const [queryContentGroupsData, setContentGroupsData] = useState<any[]>([]);
  const [landingPageDataAll, setLandingPageDataAll] = useState<any[]>([]);
  const [eventDataAll, setEventDataAll] = useState<any[]>([]);
  const [sessionSource, setSessionSource] = useState<any[]>([]);
  const [pagePath, setPagePath] = useState<any[]>([]);
  // const winnableTab = useRef(false);
  // const [winnableQueriesData, setWinnableQueriesData] = useState<any[]>([]);
  // const [winnablePagesData, setWinnablePagesData] = useState<any[]>([]);
  const [interactions, setInteractions] = useState<{
    data: any[];
    keys: any[];
  }>({ data: [], keys: [] });
  const [selectedTab, setSelectedTab] = useState(0);
  const [localPresenceQueries, setLocalPresenceQueries] = useState<any[]>([]);
  const [reviewsData, setReviewsData] = useState<any>([
    {
      alltimereviews: { Total: 0, Percent: "0%", Trend: "down" },
      alltimerating: { Total: 0, Percent: "0%", Trend: "down" },
      reviewspast: {
        Total: 0,
        Diff: "0%",
        Trend: "down",
      },
      ratingspast: {
        Total: 0,
        Diff: "0%",
        Trend: "down",
      },
    },
  ]);
  const [landingPageContentData, setLandingPageContentData] = useState<any[]>(
    []
  );
  const [trendData, setTrendData] = useState<TrendData>({
    Clk: { Total: "0", Diff: "0%", Trend: "down" },
    Imp: { Total: "0", Diff: "0%", Trend: "down" },
    goals: { Total: "0", Diff: "0%", Trend: "down" },
  });
  const [interActionTrendData, setInterActionTrendData] = useState<TrendData>({
    totalinteractions: { Total: "0", Diff: "0%", Trend: "down" },
  });

  const [aiTrendData, setAiTrendData] = useState<TrendData>({
    AiTraffic: { Total: "0", Diff: "0%", Trend: "down" },
    TotalTraffic: { Total: "0", Diff: "0%", Trend: "down" },
  });


  const [aiLineData, setAiLineData] = useState<any>({});
  const [aiBarData, setAiBarData] = useState<any>([]);

  const [loading, setLoading] = useState(true);
  const locationParams = useLocation(); // Correct variable name
  const prevUuidRef = useRef<string | null>(null);
  const getUuidFromParams = () => {
    // Retrieves 'uuid' from the URL search parameters
    const params = new URLSearchParams(locationParams.search);
    return params.get("uuid");
  };

  const [keyword, setKeyword] = useState("");
  const [keywords, setKeywords] = useState<string[]>([]);

  const [clusters, setClusters] = useState<any>([]);
  const [newCluster, setNewCluster] = useState<any>(null);
  const [newCondition, setNewCondition] = useState<any>(null);

  const [contentGroups, setContentGroups] = useState<any>([]);
  const [newContentGroup, setNewContentGroup] = useState<any>(null);
  const [newContentCondition, setNewContentCondition] = useState<any>(null);
  const settingsControl = useRef(false);
  //const [tabs, setTabs] = useState(["CLK", "IMP", "CTR", "POS"]);

  const { doApi } = useApi();
  const [businessProfileSettings, setBusinessProfileSettings] =
    useState<BusinessProfileSettings | null>(null);

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const organicRef = useRef(null);
  const webRef = useRef(null);
  const aiRef = useRef(null);
  const localRef = useRef(null);
  const reviewsRef = useRef(null);

  const [ga4Date, setGa4Date] = useState<string[]>([]);
  const [ga4Data, setGa4Data] = useState<any[]>([]);
  const [month, setMonth] = useState<string>("3 months");
  const dashboardRef = useRef(true);
  const [location, setLocation] = useState<string>("");
  const [ga4BarDate, setGa4BarDate] = useState<string[]>([]);
  const [ga4BarData, setGa4BarData] = useState<any[]>([]);
  console.log("WebsitePerformance ~ ga4BarData:", ga4BarData);
  const [topQueries, setTopQueries] = useState<any>({});
  const [topQueriesCards, setTopQueriesCards] = useState<any>({});
  const [chartReady, setChartReady] = useState(false);

  const fetchTopQueries = useCallback(async () => {
    const { Website, UniqueId } = profileData;
    const payload = {
      uniqueId: UniqueId,
      website: Website,
      origin: "ui",
      Period: month,
      dimensions: ["query"],
    };
    const fetchTopQueriesConfig: IAPIConfig = {
      URL: `/fetch-total-queries`,
      method: "POST",
      payLoad: payload,
    };

    const res: any = await doApi(fetchTopQueriesConfig, "seedmain");
    if (res.status === 200) {
      const rawData = res.data;
      if (!rawData.err) {
        const parsedDataCardsOfTopQueries = JSON.parse(rawData?.cardValues);
        const output: any = {};
        parsedDataCardsOfTopQueries.forEach(({ Item, ...rest }: any) => {
          output[Item] = rest;
        });
        setTopQueriesCards(output);
        const jsonResponse = JSON.parse(rawData?.timeSeriesDatedValues);

        if (Array.isArray(jsonResponse)) {
          const chartKeys = jsonResponse.map((row: any) => row.Date ?? "");
          const seriesData = [
            {
              name: "Pos1_3",
              data: jsonResponse.map((row: any) => row.Pos1_3 ?? 0),
            },
            {
              name: "Pos4_10",
              data: jsonResponse.map((row: any) => row.Pos4_10 ?? 0),
            },
            {
              name: "Pos11_20",
              data: jsonResponse.map((row: any) => row.Pos11_20 ?? 0),
            },
            {
              name: "Pos20_Plus",
              data: jsonResponse.map((row: any) => row.Pos20_Plus ?? 0),
            },
          ];

          setTopQueries({ data: seriesData, keys: chartKeys });
        } else {
          CustomToast("POS chart data not found.", "error");
        }
      } else {
        CustomToast(
          rawData?.msg || rawData?.message || "POS Data not found.",
          "error"
        );
      }
    }
  }, [month, doApi, CustomToast, profileData]);

  // Memoize parsed data from landingPageData
  const ga4ChartDateMemo = useMemo(() => {
    if (!landingPageData?.date) return { data: [], keys: [] };
    try {
      const parsedData: ChartData[] = JSON.parse(landingPageData.date.data);
      if (Array.isArray(parsedData)) {
        const chartKeys = parsedData.map((row) =>
          row.curDate ? dayjs(row.curDate).format("YYYY-MM-DD") : ""
        );
        const seriesData = [
          {
            name: "Sessions",
            data: parsedData.map((row) => row.curData["Sessions"] ?? 0),
          },
          {
            name: "keyEvents",
            data: parsedData.map((row) => row.curData.keyEvents ?? 0),
          },
        ];
        return { data: seriesData, keys: chartKeys };
      }
    } catch (error) {
      console.error("Error parsing JSON in ga4ChartDateMemo:", error);
    }
    return { data: [], keys: [] };
  }, [landingPageData]);

  useEffect(() => {
    if (ga4ChartDateMemo) {
      setGa4Date(ga4ChartDateMemo.keys);
      setGa4Data(ga4ChartDateMemo.data);
    }
  }, [ga4ChartDateMemo]);

  const ga4BarChartDateMemo = useMemo(() => {
    if (!landingPageData?.firstUserDefaultChannelGroup)
      return { data: [], keys: [] };

    try {
      const parsedData: BarChartData[] = JSON.parse(
        landingPageData.firstUserDefaultChannelGroup
      );
      console.log("landingPageData parsedata", parsedData);

      if (Array.isArray(parsedData)) {
        // Extract channel group keys dynamically
        const chartKeys = parsedData.map(
          (row) => row["FirstUser DefaultChannelGroup"] || ""
        );

        // Create series data for Sessions and Key events
        const sessionsSeries = {
          name: "Sessions",
          data: parsedData.map((row) =>
            row.curData?.Sessions ? parseInt(row.curData.Sessions, 10) : 0
          ),
        };

        const keyEventsSeries = {
          name: "Key events",
          data: parsedData.map((row) =>
            row.curData?.["Key events"]
              ? parseInt(row.curData["Key events"], 10)
              : 0
          ),
        };
        return { data: [sessionsSeries, keyEventsSeries], keys: chartKeys };
      }
    } catch (error) {
      console.error("Error parsing JSON in ga4ChartDateMemo:", error);
    }

    return { data: [], keys: [] };
  }, [landingPageData]);

  const memoizedGACardData = useMemo(() => {
    if (!landingPageData || !landingPageData?.date?.mainStats) {
      return {};
    }

    try {
      const jsonResponse = JSON.parse(landingPageData?.date?.mainStats);
      return jsonResponse;
    } catch (error) {
      console.error("Error parsing JSON in useMemo:", error);
    }
    return [];
  }, [landingPageData]);

  console.log("memoizedGACardData", memoizedGACardData);

  useEffect(() => {
    if (ga4BarChartDateMemo) {
      setGa4BarDate(ga4BarChartDateMemo.keys);
      const sortedData = [...ga4BarChartDateMemo.data].sort((a, b) =>
        a.name === "Key events" ? -1 : b.name === "Key events" ? 1 : 0
      );
      setGa4BarData(sortedData);
    }
  }, [ga4BarChartDateMemo]);

  const scrollToSection = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    // Scroll based on tab index
    switch (newValue) {
      case 0:
        scrollToSection(organicRef);
        setSelectedTab(0);
        break;
      case 1:
        scrollToSection(webRef);
        setSelectedTab(0);
        break;
      case 2:
        scrollToSection(aiRef);
        setSelectedTab(0);
        break;
      case 3:
        scrollToSection(localRef);
        setSelectedTab(0);
        break;
      case 4:
        scrollToSection(reviewsRef);
        setSelectedTab(0);
        break;
      default:
        setSelectedTab(0);
        break;
    }
  };

  useEffect(() => {
    const updateScreenHeight = () => {
      setScreenHeight(window.innerHeight);
    };

    // Add event listener to update screen height on resize
    window.addEventListener("resize", updateScreenHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateScreenHeight);
    };
  }, []);

  const [filteredQueries, setFilteredQueries] = useState<any[]>([]);

  useEffect(() => {
    // Instant filtering with newCondition
    if (queriesData && newCondition) {
      const filteredData = queriesData
        .flatMap((cluster: any) => cluster.queries || [])
        .filter((page: any) => {
          const conditionValue = newCondition.value.trim().toLowerCase();
          const pageContent = page.toLowerCase();

          switch (newCondition.condition) {
            case "contains":
              return pageContent.includes(conditionValue);
            case "equals":
              return pageContent === conditionValue;
            case "startsWith":
              return pageContent.startsWith(conditionValue);
            case "endsWith":
              return pageContent.endsWith(conditionValue);
            default:
              return true;
          }
        });

      setFilteredQueries(filteredData);
    }
  }, [newCondition, queriesData]);

  useEffect(() => {
    // Filtering after "Add" with newCluster.conditions
    if (queriesData && newCluster && newCluster.conditions) {
      const filteredData = queriesData
        .flatMap((cluster: any) => cluster.queries || [])
        .filter((page: any) => {
          return newCluster.conditions.every((condition: any) => {
            const conditionValue = condition.value.trim().toLowerCase();
            const pageContent = page.toLowerCase();

            switch (condition.condition) {
              case "contains":
                return pageContent.includes(conditionValue);
              case "equals":
                return pageContent === conditionValue;
              case "startsWith":
                return pageContent.startsWith(conditionValue);
              case "endsWith":
                return pageContent.endsWith(conditionValue);
              default:
                return true;
            }
          });
        });

      setFilteredQueries(filteredData);
    }
  }, [newCluster, queriesData]);

  const [filteredContentData, setFilteredContentData] = useState<any[]>([]);

  useEffect(() => {
    if (contentData && newContentCondition) {
      const conditionValue = newContentCondition.value.trim().toLowerCase();

      const filteredData = [...contentData, ...landingPageDataAll]
        .flatMap((item: any) => {
          if (item.queries) {
            return item.queries; // from contentData
          } else if (item.landing_page) {
            return [item.landing_page]; // from landingPageDataAll
          }
          return [];
        })
        .filter((page: any) => {
          const pageContent = String(page).toLowerCase();

          switch (newContentCondition.condition) {
            case "contains":
              return pageContent.includes(conditionValue);
            case "equals":
              return pageContent === conditionValue;
            case "startsWith":
              return pageContent.startsWith(conditionValue);
            case "endsWith":
              return pageContent.endsWith(conditionValue);
            default:
              return true;
          }
        });

      setFilteredContentData(filteredData);
    }
  }, [newContentCondition, contentData, landingPageDataAll]);

  useEffect(() => {
    // Filter using the newContentGroup after "Add" button is clicked
    if (contentData && newContentGroup && newContentGroup.conditions) {
      const filteredData = contentData
        .flatMap((cluster: any) => cluster.queries || [])
        .filter((page: any) => {
          return newContentGroup.conditions.every((condition: any) => {
            const conditionValue = condition.value.trim().toLowerCase();
            const pageContent = page.toLowerCase();

            switch (condition.condition) {
              case "contains":
                return pageContent.includes(conditionValue);
              case "equals":
                return pageContent === conditionValue;
              case "startsWith":
                return pageContent.startsWith(conditionValue);
              case "endsWith":
                return pageContent.endsWith(conditionValue);
              default:
                return true;
            }
          });
        });

      setFilteredContentData(filteredData);
    }
  }, [newContentGroup, contentData]);

  useEffect(() => {
    try {
      setLoading(true);
      const currentUuid = getUuidFromParams(); // Fetch the current UUID
      if (prevUuidRef.current !== currentUuid) {
        // If UUID has changed, set dashboardRef.current to true
        dashboardRef.current = true;
        prevUuidRef.current = currentUuid;
      } else {
        // Reset dashboardRef.current if UUID has not changed
        // dashboardRef.current = false;
      }
    } finally {
      setLoading(false);
    }
  }, [locationParams.search]);

  const memoizedCTrendData = useMemo(() => {
    if (
      searchConsoleTrendData === null ||
      searchConsoleTrendData === undefined ||
      Object.keys(searchConsoleTrendData).length === 0
    ) {
      return {};
    }

    try {
      const jsonResponse = JSON.parse(searchConsoleTrendData);
      return jsonResponse;
    } catch (error) {
      console.error("Error parsing JSON in useMemo:", error);
    }
    return [];
  }, [searchConsoleTrendData]);

  useEffect(() => {
    if (!memoizedCTrendData) return;

    const filteredData: any = {
      Imp: memoizedCTrendData.Imp,
      Clk: memoizedCTrendData.Clk,
    };

    if (
      memoizedCTrendData.goals !== undefined &&
      Object.keys(memoizedCTrendData.goals).length > 0
    ) {
      filteredData.Goals = memoizedCTrendData.goals;
    }

    setTrendData(filteredData);
  }, [memoizedCTrendData]);

  // const memoizedCardData = useMemo(() => {
  //   if (
  //     searchConsoleCards === undefined ||
  //     Object.keys(searchConsoleCards).length === 0
  //   ) {
  //     return {};
  //   }

  //   try {
  //     const jsonResponse = JSON.parse(searchConsoleCards);
  //     return jsonResponse;
  //   } catch (error) {
  //     console.error("Error parsing JSON in useMemo:", error);
  //   }
  //   return [];
  // }, [searchConsoleCards]);

  // useEffect(() => {
  //   setCards(memoizedCardData);
  // }, [memoizedCardData]);

  const memoizedFunnelData = useMemo(() => {
    if (
      searchConsoleFunnelData === undefined ||
      Object.keys(searchConsoleFunnelData).length === 0
    ) {
      return {};
    }

    try {
      const jsonResponse = JSON.parse(searchConsoleFunnelData);
      return jsonResponse;
    } catch (error) {
      console.error("Error parsing JSON in useMemo:", error);
    }
    return [];
  }, [searchConsoleFunnelData]);

  useEffect(() => {
    setFunnelData(memoizedFunnelData);
  }, [memoizedFunnelData]);

  const memoizedChartData = useMemo(() => {
    if (
      searchConsoleDate === null ||
      searchConsoleDate === undefined ||
      Object.keys(searchConsoleDate).length === 0
    ) {
      return { data: [], keys: [] };
    }

    try {
      const jsonResponse = JSON.parse(searchConsoleDate);
      if (jsonResponse?.rows && Array.isArray(jsonResponse.rows)) {
        const chartKeys = jsonResponse.rows.map(
          (row: any) => row.keys?.[0] ?? ""
        );
        const seriesData = [
          {
            name: "IMP",
            data: jsonResponse.rows.map((row: any) => row.impressions ?? 0),
          },
          {
            name: "CLK",
            data: jsonResponse.rows.map((row: any) => row.clicks ?? 0),
          }
        ];
        const hasGoals = jsonResponse.rows.map((row: any) => row.goal) || [];
        if (Array.isArray(hasGoals) && hasGoals.length > 0) {
          seriesData.push({
            name: "Goals",
            data: jsonResponse.rows.map((row: any) => row.goal ?? 0),
          });
        }

        return { data: seriesData, keys: chartKeys };
      }
    } catch (error) {
      console.error("Error parsing JSON in useMemo:", error);
    }
    return { data: [], keys: [] };
  }, [searchConsoleDate]);

  useEffect(() => {
    setChartData(memoizedChartData.data);
    setChartKey(memoizedChartData.keys);
  }, [memoizedChartData]);

  // Memoize queriesData based on `searchConsolePage`
  const contentDataMemo = useMemo(() => {
    if (
      searchConsolePage === null ||
      searchConsolePage === undefined ||
      Object.keys(searchConsolePage).length === 0
    )
      return;
    try {
      const jsonResponse = JSON.parse(searchConsolePage);
      console.log("fetchSearchAnalytics searchConsolePage", jsonResponse);

      return jsonResponse.rows.map((row: any) => ({
        queries: row.keys[0],
        group: row.Group,
        clk: {
          value: row.clicks,
          increase: row.stats1?.Trend === "up",
          diff: row.stats1?.Diff,
          percentage: row.stats1?.Percentage,
        },
        imp: {
          value: row.impressions,
          increase: row.stats2?.Trend === "up",
          diff: row.stats2?.Diff,
          percentage: row.stats2?.Percentage,
        },
        ctr: {
          value: row.ctr,
          increase: row.stats3?.Trend === "up",
          diff: row.stats3?.Diff,
          percentage: row.stats3?.Percentage,
        },
        pos: {
          value: row.position,
          increase: row.stats4?.Trend === "up",
          diff: row.stats4?.Diff,
          percentage: row.stats4?.Percentage,
        },
      }));
    } catch (error) {
      console.error("Error parsing JSON in queriesDataMemo:", error);
    }
    return [];
  }, [searchConsolePage]);

  useEffect(() => {
    setContentData(contentDataMemo);
  }, [contentDataMemo]);

  // Memoize queriesData based on `queryclusters`
  const queryClustersDataMemo = useMemo(() => {
    console.log("searchConsoleQueryClusters", searchConsoleQueryClusters);

    if (
      searchConsoleQueryClusters === null ||
      searchConsoleQueryClusters === undefined ||
      Object.keys(searchConsoleQueryClusters).length === 0
    )
      return;
    try {
      const jsonResponse = JSON.parse(searchConsoleQueryClusters);
      return jsonResponse.rows.map((row: any) => ({
        queries: row.keys[0],
        group: row.Group,
        clk: {
          value: row.clicks,
          increase: row.status1?.Trend === "up",
          diff: row.status1?.Diff,
          percentage: row.status1?.Percentage,
        },
        imp: {
          value: row.impressions,
          increase: row.status2?.Trend === "up",
          diff: row.status2?.Diff,
          percentage: row.status2?.Percentage,
        },
        ctr: {
          value: row.ctr,
          increase: row.status3?.Trend === "up",
          diff: row.status3?.Diff,
          percentage: row.status3?.Percentage,
        },
        pos: {
          value: row.position,
          increase: row.status4?.Trend === "up",
          diff: row.status4?.Diff,
          percentage: row.status4?.Percentage,
        },
      }));
    } catch (error) {
      console.error("Error parsing JSON in queryClustersDataMemo:", error);
    }
    return [];
  }, [searchConsoleQueryClusters]);

  useEffect(() => {
    setQueryClustersData(queryClustersDataMemo);
  }, [queryClustersDataMemo]);

  // Memoize queriesData based on `searchConsoleContentGroups`
  const searchConsoleContentGroupsDataMemo = useMemo(() => {
    if (
      searchConsoleContentGroups === null ||
      searchConsoleContentGroups === undefined ||
      Object.keys(searchConsoleContentGroups).length === 0
    )
      return;
    try {
      const jsonResponse = JSON.parse(searchConsoleContentGroups);
      return jsonResponse.rows.map((row: any) => ({
        queries: row.keys[0],
        group: row.Group,
        clk: {
          value: row.clicks,
          increase: row.status1?.Trend === "up",
          diff: row.status1?.Diff,
          percentage: row.status1?.Percentage,
        },
        imp: {
          value: row.impressions,
          increase: row.status2?.Trend === "up",
          diff: row.status2?.Diff,
          percentage: row.status2?.Percentage,
        },
        ctr: {
          value: row.ctr,
          increase: row.status3?.Trend === "up",
          diff: row.status3?.Diff,
          percentage: row.status3?.Percentage,
        },
        pos: {
          value: row.position,
          increase: row.status4?.Trend === "up",
          diff: row.status4?.Diff,
          percentage: row.status4?.Percentage,
        },
      }));
    } catch (error) {
      console.error("Error parsing JSON in contentGroupsDataMemo:", error);
    }
    return [];
  }, [searchConsoleContentGroups]);

  useEffect(() => {
    setContentGroupsData(searchConsoleContentGroupsDataMemo);
  }, [searchConsoleContentGroupsDataMemo]);

  // Memoize contentData based on `searchConsoleQuery`
  const queryDataMemo = useMemo(() => {
    if (
      searchConsoleQuery === null ||
      searchConsoleQuery === undefined ||
      Object.keys(searchConsoleQuery).length === 0
    )
      return;
    try {
      const jsonResponse = JSON.parse(searchConsoleQuery);
      console.log("jsonResponse data", jsonResponse);

      return jsonResponse.rows.map((row: any) => ({
        queries: row.keys[0],
        group: row.Group,
        clk: {
          value: row.clicks,
          increase: row.stats1?.Trend === "up",
          diff: row.stats1?.Diff,
          percentage: row.stats1?.Percentage,
        },
        imp: {
          value: row.impressions,
          increase: row.stats2?.Trend === "up",
          diff: row.stats2?.Diff,
          percentage: row.stats2?.Percentage,
        },
        ctr: {
          value: row.ctr,
          increase: row.stats3?.Trend === "up",
          diff: row.stats3?.Diff,
          percentage: row.stats3?.Percentage,
        },
        pos: {
          value: row.position,
          increase: row.stats4?.Trend === "up",
          diff: row.stats4?.Diff,
          percentage: row.stats4?.Percentage,
        },
      }));
    } catch (error) {
      console.error("Error parsing JSON in contentDataMemo:", error);
    }
    return [];
  }, [searchConsoleQuery]);

  useEffect(() => {
    setQueriesData(queryDataMemo);
  }, [queryDataMemo]);

  // Memoize contentData based on `winnable Query Data Memo`
  // const winnableQueryDataMemo = useMemo(() => {
  //   if (winnableData.data === undefined) return;
  //   try {
  //     const jsonResponse = JSON.parse(winnableData.data[1].winnableQueries);
  //     console.log("jsonResponse data", jsonResponse);

  //     return jsonResponse.rows.map((row: any) => ({
  //       queries: row.keys[0],
  //       group: row.Group,
  //       clk: {
  //         value: row.clicks,
  //         increase: row.stats1?.Trend === "up",
  //         diff: row.stats1?.Diff,
  //         percentage: row.stats1?.Percentage,
  //       },
  //       imp: {
  //         value: row.impressions,
  //         increase: row.stats2?.Trend === "up",
  //         diff: row.stats2?.Diff,
  //         percentage: row.stats2?.Percentage,
  //       },
  //       ctr: {
  //         value: row.ctr,
  //         increase: row.stats3?.Trend === "up",
  //         diff: row.stats3?.Diff,
  //         percentage: row.stats3?.Percentage,
  //       },
  //       pos: {
  //         value: row.position,
  //         increase: row.stats4?.Trend === "up",
  //         diff: row.stats4?.Diff,
  //         percentage: row.stats4?.Percentage,
  //       },
  //     }));
  //   } catch (error) {
  //     console.error("Error parsing JSON in contentDataMemo:", error);
  //   }
  //   return [];
  // }, [winnableData]);

  // useEffect(() => {
  //   setWinnableQueriesData(winnableQueryDataMemo);
  // }, [winnableQueryDataMemo]);

  // Memoize contentData based on `winnable Query Data Memo`
  // const winnablePagesDataMemo = useMemo(() => {
  //   if (winnableData.data === undefined) return;
  //   try {
  //     const jsonResponse = JSON.parse(winnableData.data[0].winnablePages);
  //     console.log("jsonResponse data", jsonResponse);

  //     return jsonResponse.rows.map((row: any) => ({
  //       queries: row.keys[0],
  //       group: row.Group,
  //       clk: {
  //         value: row.clicks,
  //         increase: row.stats1?.Trend === "up",
  //         diff: row.stats1?.Diff,
  //         percentage: row.stats1?.Percentage,
  //       },
  //       imp: {
  //         value: row.impressions,
  //         increase: row.stats2?.Trend === "up",
  //         diff: row.stats2?.Diff,
  //         percentage: row.stats2?.Percentage,
  //       },
  //       ctr: {
  //         value: row.ctr,
  //         increase: row.stats3?.Trend === "up",
  //         diff: row.stats3?.Diff,
  //         percentage: row.stats3?.Percentage,
  //       },
  //       pos: {
  //         value: row.position,
  //         increase: row.stats4?.Trend === "up",
  //         diff: row.stats4?.Diff,
  //         percentage: row.stats4?.Percentage,
  //       },
  //     }));
  //   } catch (error) {
  //     console.error("Error parsing JSON in contentDataMemo:", error);
  //   }
  //   return [];
  // }, [winnableData]);

  // useEffect(() => {
  //   setWinnablePagesData(winnablePagesDataMemo);
  // }, [winnablePagesDataMemo]);

  // Memoize landingPageDataAll based on `landingPageData?.landingPage`
  const landingPageDataAllMemo = useMemo(() => {
    if (!landingPageData?.landingPage) return [];
    try {
      const convertJsonData = JSON.parse(landingPageData.landingPage);
      console.log("landingPageData convertJsonData", convertJsonData);

      if (Array.isArray(convertJsonData)) {
        return convertJsonData.map((item: any) => ({
          group: item?.Group,
          landing_page: item["Landing page"],
          sessions: item.Sessions,
          engagement: item["Engagement Rate"],
          bounce: item["Bounce rate"],
          key_events: item["Key events"],
          conversions: item.Conversions,
        }));
      }
    } catch (error) {
      console.error("Error parsing JSON in landingPageDataAllMemo:", error);
    }
    return [];
  }, [landingPageData?.landingPage]);

  useEffect(() => {
    setLandingPageDataAll(landingPageDataAllMemo);
  }, [landingPageDataAllMemo]);

  // Memoize eventDataAllMemo based on `landingPageData?.eventName`
  const eventDataAllMemo = useMemo(() => {
    if (!landingPageData?.eventName) return [];
    try {
      const convertJsonData = JSON.parse(landingPageData.eventName);
      console.log("landingPageData convertJsonData", convertJsonData);

      if (Array.isArray(convertJsonData)) {
        return convertJsonData.map((item: any) => ({
          group: item?.Group,
          landing_page: item.eventName,
          goals: item.keyEvents,
        }));
      }
    } catch (error) {
      console.error("Error parsing JSON in eventDataAllMemo:", error);
    }
    return [];
  }, [landingPageData?.eventName]);

  useEffect(() => {
    setEventDataAll(eventDataAllMemo);
  }, [eventDataAllMemo]);

  // Memoize eventDataAllMemo based on `landingPageData?.sessionSource`
  const sessionSourceAllMemo = useMemo(() => {
    if (!landingPageData?.sessionSource) return [];
    try {
      const convertJsonData = JSON.parse(landingPageData.sessionSource);
      console.log("landingPageData convertJsonData", convertJsonData);

      if (Array.isArray(convertJsonData)) {
        return convertJsonData.map((item: any) => ({
          group: item?.Group,
          landing_page: item.sessionSource,
          sessions: item.sessions,
          goals: item.keyEvents || "0",
        }));
      }
    } catch (error) {
      console.error("Error parsing JSON in eventDataAllMemo:", error);
    }
    return [];
  }, [landingPageData?.sessionSource]);

  useEffect(() => {
    setSessionSource(sessionSourceAllMemo);
  }, [sessionSourceAllMemo]);

  // Memoize eventDataAllMemo based on `landingPageData?.pagePath`
  const pagePathAllMemo = useMemo(() => {
    if (!landingPageData?.pagePath) return [];
    try {
      const convertJsonData = JSON.parse(landingPageData.pagePath);
      console.log("landingPageData convertJsonData", convertJsonData);

      if (Array.isArray(convertJsonData)) {
        return convertJsonData.map((item: any) => ({
          group: item?.Group,
          landing_page: item.pagePath,
          sessions: item.sessions,
          goals: item.keyEvents || "0",
        }));
      }
    } catch (error) {
      console.error("Error parsing JSON in eventDataAllMemo:", error);
    }
    return [];
  }, [landingPageData?.pagePath]);

  useEffect(() => {
    setPagePath(pagePathAllMemo);
  }, [pagePathAllMemo]);

  // Memoize landingPageContentData based on `landingPageData?.firstUserDefaultChannelGroup`
  const landingPageContentDataMemo = useMemo(() => {
    if (!landingPageData?.landingPageContentGroup) return [];
    try {
      const convertJsonData = JSON.parse(
        landingPageData.landingPageContentGroup
      );
      if (Array.isArray(convertJsonData)) {
        return convertJsonData.map((item: any) => ({
          group: item?.Group,
          landing_page: item["Landing page"],
          sessions: item.Sessions,
          goals: item["Key events"],
        }));
      }
    } catch (error) {
      console.error("Error parsing JSON in landingPageContentDataMemo:", error);
    }
    return [];
  }, [landingPageData?.landingPageContentGroup]);

  useEffect(() => {
    setLandingPageContentData(landingPageContentDataMemo);
  }, [landingPageContentDataMemo]);

  //GDP

  const memoizedAIData = useMemo(() => {
    if (
      searchAiData === null ||
      searchAiData === undefined ||
      Object.keys(searchAiData).length === 0
    ) {
      return {
        data: [
          {
            name: "AiTraffic",
            data: [0],
          },
        ],
        keys: [dayjs().format("YYYY-MM-DD")],
      };
    }
    try {
      const jsonResponse = JSON.parse(searchAiData.data);
      const timeSeriesData: any = JSON.parse(
        jsonResponse.timeSeriesDatedValues
      );
      // debugger;
      const aiTraffic = JSON.parse(jsonResponse.AITraffic);
      const aiTotalTraffic = JSON.parse(jsonResponse.TotalTraffic);
       const aiKeyEvents = JSON.parse(jsonResponse.AIKeyEvents);
      const trafficByAISource = JSON.parse(jsonResponse.trafficByAISource);
      setAiBarData(trafficByAISource);
      // Set total interactions in trend data
      setAiTrendData({ AiTraffic: aiTraffic, TotalTraffic: aiTotalTraffic, AIKeyEvents:aiKeyEvents });

      // Prepare keys and series data for chart
      const chartKeys = timeSeriesData
        .sort(
          (a: any, b: any) =>
            dayjs(String(a.Date), "YYYYMMDD").toDate().getTime() -
            dayjs(String(b.Date), "YYYYMMDD").toDate().getTime()
        )
        .map((row: any) =>
          dayjs(String(row.Date), "YYYYMMDD").format("YYYY-MM-DD")
        );
      const seriesData: any = [
        {
          name: "AiTraffic",
          data: timeSeriesData.map((row: any) => row.Value ?? 0),
        },
      ];

      return { data: seriesData, keys: chartKeys };
    } catch (error) {
      console.error(
        "Error parsing JSON in memoizedChartLocalPresenceDate:",
        error
      );
      return {
        data: [
          {
            name: "AiTraffic",
            data: [0], // Placeholder value for the graph
          },
        ],
        keys: [dayjs().format("YYYY-MM-DD")],
      };
    }
  }, [searchAiData]);

  useEffect(() => {
    setAiLineData(memoizedAIData);
  }, [memoizedAIData]);

  const memoizedChartLocalPresenceDate = useMemo(() => {
    if (
      localPresence?.interactions === undefined ||
      localPresence?.interactions === null ||
      JSON.parse(localPresence.interactions)?.err
    )
      return {
        data: [
          {
            name: "Interactions",
            data: [0],
          },
        ],
        keys: [dayjs().format("YYYY-MM-DD")],
      };

    try {
      const jsonResponse = JSON.parse(localPresence.interactions);
      const timeSeriesData: any = JSON.parse(
        jsonResponse.timeSeriesDatedValues
      );
      const totalInteractions = JSON.parse(jsonResponse.totalinteractions);

      // Set total interactions in trend data
      setInterActionTrendData({ totalinteractions: totalInteractions });
      // Prepare keys and series data for chart
      const chartKeys = timeSeriesData.map((row: any) =>
        dayjs(
          `${row.Date.slice(4, 8)}-${row.Date.slice(2, 4)}-${row.Date.slice(
            0,
            2
          )}`
        ).format("YYYY-MM-DD")
      );
      const seriesData: any = [
        {
          name: "Interactions",
          data: timeSeriesData.map((row: any) => row.Value ?? 0),
        },
      ];

      return { data: seriesData, keys: chartKeys };
    } catch (error) {
      console.error(
        "Error parsing JSON in memoizedChartLocalPresenceDate:",
        error
      );
      return {
        data: [
          {
            name: "Interactions",
            data: [0], // Placeholder value for the graph
          },
        ],
        keys: [dayjs().format("YYYY-MM-DD")],
      };
    }
  }, [localPresence]);

  // Set interactions when chart data is memoized
  useEffect(() => {
    setInteractions(memoizedChartLocalPresenceDate);
  }, [memoizedChartLocalPresenceDate]);

  // Memoized calculation for queries data
  const memoizedChartLocalPresenceQueries = useMemo(() => {
    if (localPresence?.queries === undefined || localPresence.queries === null)
      return [];

    try {
      const jsonResponse = JSON.parse(localPresence.queries);
      const rows = JSON.parse(jsonResponse.rows);

      return rows.map((row: { Query: string; Value: number }) => ({
        queries: row.Query,
        searches: { value: row.Value },
      }));
    } catch (error) {
      console.error(
        "Error parsing JSON in memoizedChartLocalPresenceQueries:",
        error
      );
      return [];
    }
  }, [localPresence]);

  // Set queries data when memoized
  useEffect(() => {
    setLocalPresenceQueries(memoizedChartLocalPresenceQueries);
  }, [memoizedChartLocalPresenceQueries]);

  // Memoized calculation for queries data
  const memoizedChartLocalPresenceReviews = useMemo(() => {
    if (localPresence?.reviews === undefined || localPresence.reviews === null)
      return [];

    try {
      const jsonResponse = JSON.parse(localPresence.reviews);
      return jsonResponse;
    } catch (error) {
      console.error(
        "Error parsing JSON in memoizedChartLocalPresenceReviews:",
        error
      );
      return [];
    }
  }, [localPresence]);

  // Set queries data when memoized
  useEffect(() => {
    setReviewsData(memoizedChartLocalPresenceReviews);
  }, [memoizedChartLocalPresenceReviews]);

  useEffect(() => {
    if (profileData.Locations && profileData.Locations.length > 0) {
      setLocation(profileData.Locations[0].Name);
    }
  }, [profileData]);

  // console.log("profileData.UniqueId",profileData.UniqueId);
  const fetchSearchAnalyticsData = useCallback(async () => {
    const { Website, UniqueId } = profileData; // Destructure for clarity
    if (Website && UniqueId) {
      const values = {
        uniqueId: UniqueId,
        website: Website,
        origin: "ui",
        Period: month,
        dimensions: ["date", "page", "query"],
      };

      try {
        await FetchSearchAnalytics(values);
      } catch (error) {
        console.error("Error fetching search analytics data:", error);
      }
    }
  }, [month, profileData.Website, profileData.UniqueId]);

  // console.log("profileData.UniqueId",profileData.UniqueId);
  const fetchAISearchAnalyticsData = useCallback(async () => {
    const { Website, UniqueId } = profileData;
    if (Website && UniqueId) {
      const values = {
        uniqueId: UniqueId,
        website: Website,
        origin: "ui",
        Period: month,
        mode: "changemetric",
        dimensions: [
          {
            name: "date",
          },
          {
            name: "sessionSource",
          },
        ],
        metrics: [
          {
            name: "sessions",
          },
          {
            name: "keyEvents",
          },
        ],
      };

      try {
        await FetchAISearchData(values);
      } catch (error) {
        console.error("Error fetching search analytics data:", error);
      }
    }
  }, [month, profileData.Website, profileData.UniqueId]);

  const fetchGA4Data = useCallback(async () => {
    const { Website, UniqueId } = profileData;
    if (Website && UniqueId) {
      const GA4Payload = {
        uniqueId: UniqueId,
        website: Website,
        origin: "ui",
        period: month,
        mode: "changemetric",
        dimensions: [
          {
            name: "landingPage",
            metrics: [
              {
                name: "sessions",
              },
              {
                name: "engagementRate",
              },
              {
                name: "bounceRate",
              },
              {
                name: "keyEvents",
              },
            ],
          },
          {
            name: "firstUserDefaultChannelGroup",
            metrics: [
              {
                name: "sessions",
              },
              {
                name: "keyEvents",
              },
            ],
          },
          {
            name: "date",
            metrics: [
              {
                name: "Key events",
              },
              {
                name: "Sessions",
              },
            ],
          },
          {
            name: "eventName",
            metrics: [
              {
                name: "keyEvents",
              },
            ],
          },
          {
            name: "sessionSource",
            metrics: [
              {
                name: "sessions",
              },
              {
                name: "keyEvents",
              },
            ],
          },
          {
            name: "pagePath",
            metrics: [
              {
                name: "sessions",
              },
              {
                name: "keyEvents",
              },
            ],
          },
        ],
      };

      try {
        await FetchGA4Data(GA4Payload);
      } catch (error) {
        console.error("Error fetching GA4 data:", error);
      }
    }
  }, [month, profileData.Website, profileData.UniqueId]);

  const fetchLocalPresence = useCallback(async () => {
    const { UniqueId } = profileData;
    if (UniqueId && location) {
      const payload = {
        uniqueId: UniqueId,
        period: month,
        location,
      };

      try {
        await FetchLocalPresence(payload);
      } catch (error) {
        console.error("Error fetching local presence data:", error);
      }
    }
  }, [month, profileData.UniqueId, location]);

  // const fetchWinnableData = useCallback(async () => {
  //   const { Website, UniqueId } = profileData;
  //   if (Website && UniqueId) {
  //     const values = {
  //       uniqueId: UniqueId,
  //       website: Website,
  //       origin: "ui",
  //       Period: month,
  //       dimensions: ["date", "page", "query"],
  //     };

  //     try {
  //       await FetchWinnableData(values);
  //     } catch (error) {
  //       console.error("Error fetching winnable data:", error);
  //     }
  //   }
  // }, [month, profileData.Website, profileData.UniqueId]);

  const handleChange = (e: any) => {
    setLocation(e.target.value);
  };

  // useEffect(() => {
  //   const winnableDataFunc = async () => {
  //     setLoading(true);
  //     await fetchWinnableData();
  //     setLoading(false);
  //   };
  //   if (winnableTab.current) {
  //     winnableDataFunc();
  //     winnableTab.current = false;
  //   }
  // }, [winnableTab.current]);

  useEffect(() => {
    const localPresc = async () => {
      await fetchLocalPresence();
    };

    if (location !== "") {
      localPresc();
    }
  }, [location, month]);

  useEffect(() => {
    if (profileData.Website && dashboardRef.current) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);

      const fetchAllData = async () => {
        setLoading(true);
        // dashboardRef.current = false;

        try {
          // Step 1: Await GSC and GBP
          await Promise.all([
            fetchSearchAnalyticsData(), // GSC
            fetchGA4Data(), // GBP
          ]);

          // ✅ GSC and ga4 are done — stop loading spinner
          setLoading(false);

          // Step 2: Now load chart data and track it separately
          fetchTopQueries()
            .then(() => setChartReady(true)) // ✅ chart is ready
            .catch((err) => {
              console.error("Top queries error:", err);
              setChartReady(true); // optional fallback
            });
          fetchAISearchAnalyticsData().catch((err) =>
            console.error("AI error:", err)
          );
        } catch (error) {
          console.error("Error during GSC/GBP fetch:", error);
          setLoading(false); // Also stop loading if GSC/GBP fail
        }
      };

      fetchAllData();
    }
  }, [profileData.Website, month]);

  const transformBusinessProfileData = (data: any): BusinessProfileSettings => {
    const transformedData: BusinessProfileSettings = {
      uniqueId: data.UniqueId,
      userUniqueId: data.UserUniqueId,
      brandedKeywords:
        data.BrandedKeywords !== "null" ? JSON.parse(data.BrandedKeywords) : [],
      topicClusters:
        data.TopicClusters !== "null"
          ? JSON.parse(data.TopicClusters).map((cluster: any) => ({
              name: cluster.Name,
              conditions: cluster.Conditions.map((condition: any) => ({
                condition: condition.Condition,
                value: condition.Value,
              })),
            }))
          : [],
      contentGroups:
        data.ContentGroups !== "null"
          ? JSON.parse(data.ContentGroups).map((group: any) => ({
              name: group.Name,
              conditions: group.Conditions.map((condition: any) => ({
                condition: condition.Condition,
                value: condition.Value,
              })),
            }))
          : [],
    };

    return transformedData;
  };

  useEffect(() => {
    dashboardRef.current = true;
  }, [month]);

  const timePeriods = useMemo(
    () => [
      {
        id: 1,
        label: "7 days",
        value: "7 days",
      },
      {
        id: 2,
        label: "14 days",
        value: "14 days",
      },
      {
        id: 3,
        label: "28 days",
        value: "28 days",
      },
      {
        id: 4,
        label: "3 months",
        value: "3 months",
      },
      {
        id: 5,
        label: "6 months",
        value: "6 months",
      },
      {
        id: 6,
        label: "12 months",
        value: "12 months",
      },
    ],
    []
  );

  // const handleViewOrientation = (
  //   _event: React.SyntheticEvent,
  //   newValue: string
  // ) => {
  //   setTabs(
  //     (prevTabs) =>
  //       prevTabs.includes(newValue)
  //         ? prevTabs.filter((tab) => tab !== newValue) // Deselect if already selected
  //         : [...prevTabs, newValue] // Select if not already selected
  //   );
  // };

  useEffect(() => {
    if (
      businessProfileSettings !== null &&
      Object.keys(businessProfileSettings).length > 0
    ) {
      setKeywords(businessProfileSettings.brandedKeywords);
      setClusters(businessProfileSettings.topicClusters);
      setContentGroups(businessProfileSettings.contentGroups);
    }
  }, [businessProfileSettings]);

  const handleAddKeyword = () => {
    if (keyword.trim() && !keywords.includes(keyword.trim())) {
      setKeywords((prev) => [...prev, keyword.trim()]);
      settingsControl.current = true;
    }
    setKeyword("");
  };

  const handleRemoveKeyword = (removedKeyword: string) => {
    setKeywords((prev) => prev.filter((kw) => kw !== removedKeyword));
    settingsControl.current = true;
  };

  const fetchBusinessProfileSettings = useCallback(async () => {
    const fetchBusinessProfileSettingsConfig: IAPIConfig = {
      URL: `Profile/GetBusinessProfileSettings?businessUniqueId=${profileData.UniqueId}&userUniqueId=${profileData.UserUniqueId}`,
      method: "GET",
    };

    const res: any = await doApi(
      fetchBusinessProfileSettingsConfig,
      "seedcore"
    );
    if (res.status === 200) {
      const rawData = res.data.data;
      const parsedData = JSON.parse(rawData);
      const normalizedData = transformBusinessProfileData(parsedData);
      setBusinessProfileSettings(normalizedData);
    } else {
      CustomToast("Failed to fetch business profile settings.", "error");
    }
  }, [profileData, doApi, CustomToast]);

  const updateBusinessProfileSettings = useCallback(async () => {
    const finalClusters = clusters.map(
      ({
        index,
        ...rest
      }: {
        index?: number;
        name: string;
        conditions: { condition: string; value: string }[];
      }) => rest
    );
    const finalContentGroups = contentGroups.map(
      ({
        index,
        ...rest
      }: {
        index?: number;
        name: string;
        conditions: { condition: string; value: string }[];
      }) => rest
    );

    const inputPayload = {
      id: profileData.id,
      uniqueId: profileData.UniqueId,
      userUniqueId: profileData.UserUniqueId,
      brandedKeywords: keywords,
      topicClusters: finalClusters,
      contentGroups: finalContentGroups,
    };

    const updateBusinessProfileSettingsConfig = {
      URL: `Profile/UpdateBusinessProfileSettings`,
      method: "POST",
      payLoad: inputPayload,
    };

    try {
      const res: any = await doApi(
        updateBusinessProfileSettingsConfig,
        "seedcore"
      );

      if (res.status === 200) {
        fetchBusinessProfileSettings();
        dashboardRef.current = true;
      } else {
        console.log("Failed to update business profile settings.");
      }
    } catch (error) {
      console.log(
        "Failed to update business profile settings due to an error."
      );
    }
  }, [profileData, keywords, doApi, CustomToast]);

  const secondTabRef = useRef(false);

  useEffect(() => {
    if (secondTabRef.current && selectedTab === 5) {
      fetchBusinessProfileSettings();
      secondTabRef.current = false;
    }
  }, [secondTabRef.current, selectedTab]);

  useEffect(() => {
    if (settingsControl.current) {
      updateBusinessProfileSettings();
      settingsControl.current = false;
    }
  }, [settingsControl.current]);

  // Initialize a new content group with one condition
  const startNewContentGroup = () => {
    setNewContentGroup({ name: "", conditions: [], index: -1 });
    setNewContentCondition({ condition: "contains", value: "" });
  };

  // Set the content group to edit
  const editContentGroup = (index: number) => {
    setNewContentGroup({ ...contentGroups[index], index });
  };

  // Remove the content group by index
  const removeContentGroup = (index: number) => {
    setContentGroups(contentGroups.filter((_: any, i: number) => i !== index));
    settingsControl.current = true;
    setNewContentGroup(null);
  };

  // Save content group - updates if editing, adds new if creating
  const saveContentGroup = () => {
    if (newContentGroup?.name === "") {
      CustomToast("Please enter Content Group Name.", "error");
      return;
    }
    let updatedContentGroup = { ...newContentGroup };

    // Check if there is an unsaved condition
    if (newContentCondition?.value) {
      updatedContentGroup = {
        ...newContentGroup,
        conditions: [...newContentGroup.conditions, newContentCondition],
      };
    }

    if (updatedContentGroup.index >= 0) {
      // Update existing content group
      setContentGroups(
        contentGroups.map((content: any, index: number) =>
          index === updatedContentGroup.index
            ? { ...updatedContentGroup, index: -1 }
            : content
        )
      );
    } else {
      // Add new content group
      setContentGroups([
        ...contentGroups,
        { ...updatedContentGroup, index: -1 },
      ]);
    }
    settingsControl.current = true;
    setNewContentGroup(null); // Reset new content group state
    setNewContentCondition(null); // Reset the condition state
  };

  // Cancel the content group creation/editing
  const cancelContentGroup = () => {
    setNewContentGroup(null);
    setNewContentCondition(null);
  };

  // Save the current condition and initialize a new empty one
  const saveContentCondition = () => {
    if (newContentCondition.value) {
      setNewContentGroup({
        ...newContentGroup,
        conditions: [...newContentGroup.conditions, newContentCondition],
      });
      setNewContentCondition({ condition: "contains", value: "" }); // Reset condition
    }
  };

  // Initialize a new cluster with one condition
  const startNewCluster = () => {
    setNewCluster({ name: "", conditions: [], index: -1 });
    setNewCondition({ condition: "contains", value: "" });
  };

  // Set the cluster to edit
  const editCluster = (index: number) => {
    setNewCluster({ ...clusters[index], index });
    setNewCondition({ condition: "contains", value: "" });
  };

  // Remove the cluster by index
  const removeCluster = (index: number) => {
    setClusters(clusters.filter((_: any, i: number) => i !== index));
    settingsControl.current = true;
    setNewCluster(null);
  };

  // Save cluster - updates if editing, adds new if creating
  const saveCluster = () => {
    if (!newCluster) return;
    if (newCluster?.name === "") {
      CustomToast("Please enter Cluster Name.", "error");
      return;
    }
    const updatedConditions = [...newCluster.conditions];

    // Add any unsaved condition
    if (newCondition && newCondition.value) {
      updatedConditions.push(newCondition);
    }

    const updatedCluster = { ...newCluster, conditions: updatedConditions };

    if (newCluster.index >= 0) {
      // Update existing cluster
      setClusters(
        clusters.map((cluster: any, index: number) =>
          index === newCluster.index
            ? { ...updatedCluster, index: -1 }
            : cluster
        )
      );
    } else {
      // Add new cluster
      setClusters([...clusters, { ...updatedCluster, index: -1 }]);
    }
    settingsControl.current = true;
    setNewCluster(null); // Reset newCluster state
    setNewCondition(null); // Reset newCondition state
  };

  // Cancel the cluster creation/editing
  const cancelCluster = () => {
    setNewCluster(null);
    setNewCondition(null);
  };

  // Save the current condition and initialize a new empty one
  const saveCondition = () => {
    if (newCondition.value) {
      setNewCluster({
        ...newCluster,
        conditions: [...newCluster.conditions, newCondition],
      });
      setNewCondition({ condition: "contains", value: "" });
    }
  };

  return (
    <AnalyticsTemplate
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      month={month}
      setMonth={setMonth}
      timePeriods={timePeriods}
      handleTabChange={handleTabChange}
      organicRef={organicRef}
      webRef={webRef}
      aiRef={aiRef}
      ChartData={ChartData}
      ChartKey={ChartKey}
      trendData={trendData}
      queryContentGroupsData={queryContentGroupsData}
      contentData={contentData}
      queriesData={queriesData}
      queryClustersData={queryClustersData}
      screenHeight={screenHeight}
      loading={loading}
      goals={eventDataAll}
      ga4Data={ga4Data}
      ga4Date={ga4Date}
      memoizedGACardData={memoizedGACardData}
      ga4BarData={ga4BarData}
      ga4BarDate={ga4BarDate}
      sessionSource={sessionSource}
      landingPageContentData={landingPageContentData}
      pagePath={pagePath}
      location={location}
      handleChange={handleChange}
      profileData={profileData}
      interactions={interactions}
      interActionTrendData={interActionTrendData}
      localPresenceQueries={localPresenceQueries}
      localRef={localRef}
      keyword={keyword}
      setKeyword={setKeyword}
      handleAddKeyword={handleAddKeyword}
      keywords={keywords}
      handleRemoveKeyword={handleRemoveKeyword}
      newCluster={newCluster}
      clusters={clusters}
      editCluster={editCluster}
      startNewCluster={startNewCluster}
      setNewCluster={setNewCluster}
      newCondition={newCondition}
      setNewCondition={setNewCondition}
      saveCondition={saveCondition}
      saveCluster={saveCluster}
      cancelCluster={cancelCluster}
      removeCluster={removeCluster}
      filteredQueries={filteredQueries}
      newContentGroup={newContentGroup}
      contentGroups={contentGroups}
      editContentGroup={editContentGroup}
      startNewContentGroup={startNewContentGroup}
      setNewContentGroup={setNewContentGroup}
      newContentCondition={newContentCondition}
      setNewContentCondition={setNewContentCondition}
      saveContentCondition={saveContentCondition}
      saveContentGroup={saveContentGroup}
      cancelContentGroup={cancelContentGroup}
      removeContentGroup={removeContentGroup}
      filteredContentData={filteredContentData}
      secondTabRef={secondTabRef}
      funnelData={funnelData}
      aiTrendData={aiTrendData}
      aiBarData={aiBarData}
      aiLineData={aiLineData}
      reviewsData={reviewsData}
      reviewsRef={reviewsRef}
      topQueriesCards={topQueriesCards}
      topQueries={topQueries}
      chartReady={chartReady}
    />
  );
};

export default BusinessDashboardV2;
